import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ResetPasswordService} from './reset-password.service';
import {HeaderService} from '../header/header.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NotifierService} from '../notifier/notifier.service';
import {NotificationType} from '../notifier/notification-type.enum';
import {ResetChange} from "./reset-change.enum";

@Component({
  selector: 'pbc-reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {

  resetForm: FormGroup;
  passwordSent: boolean = false;
  private email: string;
  mode : ResetChange = ResetChange.RESET;

  static readonly resetPasswordHeader = "Przypomnienie hasła";
  static readonly resetPasswordTitle = "Nie pamiętasz hasła?";
  static readonly resetNavigateBack = "Wróć na stronę główną";

  static readonly changePasswordHeader = "Zmiana hasła";
  static readonly changePasswordTitle = "Chcesz zmienić hasło?";
  static readonly changeNavigateBack = "Wróć do serwisu";

  header : string = "";
  title : string = "";
  navigateBack : string = "";

  resetChange = ResetChange;

  constructor(
    private resetPasswordService: ResetPasswordService,
    private headerService: HeaderService,
    private router: Router,
    private route : ActivatedRoute,
    private notifierService: NotifierService
  ) {
  this.resetForm = new FormGroup({
      'email' : new FormControl('', [Validators.required, Validators.email])
    });
  }

  ngOnInit() {
    this.headerService.isHomepage(false);
    this.route.url.subscribe(url => {
      if (url[0].path === 'reset-password')
        this.mode = ResetChange.RESET;
      else
        this.mode = ResetChange.CHANGE;

      if (this.mode == ResetChange.CHANGE) {
        this.title = ResetPasswordComponent.changePasswordTitle;
        this.header = ResetPasswordComponent.changePasswordHeader;
        this.navigateBack = ResetPasswordComponent.changeNavigateBack;
      } else {
        this.title = ResetPasswordComponent.resetPasswordTitle;
        this.header = ResetPasswordComponent.resetPasswordHeader;
        this.navigateBack = ResetPasswordComponent.resetNavigateBack;
      }
    });
  }

  sendLinkForPasswordChange() {
    this.email = this.resetForm.controls['email'].value;
    this.resetPasswordService.sendLinkForPasswordChange(this.resetForm.controls['email'].value, this.mode).subscribe(
      (response: {status: number, message: string}) => {
        if (response.status==1) {
          this.passwordSent = true;
        } else {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, response.message);
        }
      }
    );
  }

  navigateBackClick() {
    this.router.navigate(['login']).then(
      success => {},
      error => {}
    )
  }
}
